// src/redux/slices/themeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { settingsService } from '../../services/settingsService.js'
import { handleApiError } from '../../utils/handleApiError.js'

export const fetchThemeSettings = createAsyncThunk(
  'theme/fetchThemeSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await settingsService.getThemeSettings()
      return response
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

export const updateThemeSettings = createAsyncThunk(
  'theme/updateThemeSettings',
  async (settings, { rejectWithValue }) => {
    try {
      const response = await settingsService.updateThemeSettings(settings)
      return response
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    settings: null,
    loading: false,
    error: null
  },
  reducers: {
    updateColors: (state, action) => {
      if (state.settings) {
        state.settings = { ...state.settings, ...action.payload }
      }
    },
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Theme Settings
      .addCase(fetchThemeSettings.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchThemeSettings.fulfilled, (state, action) => {
        state.loading = false
        state.settings = action.payload
        state.error = null
      })
      .addCase(fetchThemeSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Update Theme Settings
      .addCase(updateThemeSettings.pending, (state) => {
        state.loading = true
      })
      .addCase(updateThemeSettings.fulfilled, (state, action) => {
        state.loading = false
        state.settings = action.payload
        state.error = null
      })
      .addCase(updateThemeSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { updateColors, clearError } = themeSlice.actions
export default themeSlice.reducer